export default function AboutSection() {
  return (
    <section id="about" className="py-28 md:py-36 bg-[#FAF9F6]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col lg:flex-row items-center gap-16 xl:gap-24">
          {/* Left Image */}
          <div className="w-full lg:w-[480px] flex-shrink-0">
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-full h-full rounded-2xl border-2 border-amber-200"></div>
              <img
                src="https://public.readdy.ai/ai/img_res/120d02c0ffded06edfb1481b72bb4f18.jpg"
                alt="DUGAN d.o.o. team"
                className="relative z-10 w-full h-[360px] object-cover object-top rounded-2xl"
              />
              {/* Badge */}
              <div className="absolute -bottom-6 -right-6 z-20 bg-white rounded-2xl shadow-lg p-5 flex items-center gap-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-amber-50">
                  <i className="ri-shield-check-line text-2xl text-amber-500"></i>
                </div>
                <div>
                  <p className="text-2xl font-extrabold text-gray-900 leading-none">5+</p>
                  <p className="text-xs text-gray-500 mt-1">Years of Excellence</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Content */}
          <div className="flex-1">
            <p className="text-amber-500 text-xs font-semibold uppercase tracking-[0.3em] mb-4">
              / Who We Are
            </p>
            <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-6">
              Experts in Modern<br />iOS Development
            </h2>
            <p className="text-gray-500 text-lg leading-relaxed mb-6">
              <strong className="text-gray-700">DUGAN d.o.o.</strong> is a dedicated team of iOS specialists with a passion for
              crafting high-quality, reliable applications that users love. We combine technical
              depth with thoughtful design to deliver products that truly stand out on the App Store.
            </p>
            <p className="text-gray-500 text-lg leading-relaxed mb-10">
              Founded with a mission to make mobile experiences safer and more efficient, our team
              brings expertise across security engineering, UI/UX design, and iOS performance
              optimization. Every product we build is a reflection of our commitment to excellence.
            </p>


          </div>
        </div>
      </div>
    </section>
  );
}
